<template>
    <v-container class="background">
        <v-row
            class="text-center"
            justify="center"
            align="center"
            style="height: 100vh;">
            <v-col
                class="cor-branca"
                cols="12"
                md="10">
                <h1>Seja bem-vindo aos Games Educativos</h1>
                <v-btn
                    large
                    block
                    rounded
                    color="primary"
                    :class="classe"
                    @click="goToQuiz('quizras')">
                    <v-icon left :size="fontSize">mdi-help</v-icon>
                    Quiz (V/F ou Múltiplas Opções)
                </v-btn>
                <v-btn
                    large
                    block
                    rounded
                    color="orange"
                    :class="classe"
                    @click="goToQuiz('qb1')">
                    <v-icon left :size="fontSize">mdi-head</v-icon>
                    Quebra Cabeça (Semmelweis)
                </v-btn>
                <v-btn
                    large
                    block
                    rounded
                    color="purple"
                    :class="classe"
                    @click="goToQuiz('qb2')">
                    <v-icon left :size="fontSize">mdi-head</v-icon>
                    Quebra Cabeça (HM)

                </v-btn>
                <v-btn
                    large
                    block
                    rounded
                    color="yellow"
                    :class="classe"
                    @click="goToQuiz('mg1')">
                    <v-icon left :size="fontSize">mdi-brain </v-icon>
                    Jogo da Memória
                </v-btn>
                <v-btn
                    large
                    block
                    rounded
                    color="#0f2399"
                    :class="classe"
                    @click="goToQuiz('roleta')">
                    <v-icon left :size="fontSize">mdi-rotate-3d-variant </v-icon>
                    Roleta
                </v-btn>
                <v-btn
                    large
                    block
                    rounded
                    color="#dadf28"
                    :class="classe"
                    @click="openManual">
                    <v-icon left :size="fontSize">mdi-school-outline</v-icon>
                    Aprenda a Usar
                </v-btn>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "BemVindo",
    data() {
        return {
            fontSize: 46,
            classe: "mt-4 py-8 px-7 text-h5",
        };
    },
    methods: {
        goToQuiz(name) {
            this.$router.push("/" + name);
        },
        openManual() {
    window.open('/docs/manual.pdf', '_blank');
  }

    },
};
</script>

<style scoped>
.cor-branca {
    background-color: rgb(255, 255, 255, 0.5);
    /* Branco com 50% de transparência */
    border-radius: 15px;
    /* Define os cantos arredondados */
}

.background {
    background-image: url("/public/img/back/GAME.jpg");
    background-size: cover;
    background-position: center;
    height: 100vh;
}

h1 {
    color: rgb(0, 42, 255);
    /* text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7); Sombra com 70% de opacidade */
    font-size: 3rem;
    font-weight: bold;
    margin-bottom: 1.5rem;
}

.v-btn {
    position: relative;
    overflow: hidden;

    border-radius: 50px;
    /* Faz o botão arredondado */
    /* background: linear-gradient(to bottom, #e0e0e0, #ffffff, #e0e0e0); Gradiente cilíndrico base */
    color: white;
    font-weight: bold;
    text-transform: uppercase;
    transition: all 0.2s ease-in-out;
    box-shadow: inset 0px -2px 5px rgba(0, 0, 0, 0.3),
        /* Sombra interna */
        0px 4px 8px rgba(0, 0, 0, 0.3);
    /* Sombra externa */
}

/* Botão Azul para Quiz HAB */
.v-btn.primary {
    background: linear-gradient(to bottom, #1565c0, #1e88e5, #1565c0);
    /* Azul com gradiente */
    color: white;
}

/* Botão Azul Claro para Quiz Nacional */
.v-btn.blue {
    background: linear-gradient(to bottom, #42a5f5, #64b5f6, #42a5f5);
    /* Azul claro com gradiente */
    color: white;
}

/* Botão Verde para Quiz Internacional */
.v-btn.green {
    background: linear-gradient(to bottom, #43a047, #66bb6a, #43a047);
    /* Verde com gradiente */
    /* color: white; */
}

/* Botão Laranja para Quebra-Cabeça */
.v-btn.orange {
    background: linear-gradient(to bottom, #fb8c00, #ffa726, #fb8c00);
    /* Laranja com gradiente */
    color: white;
}

.v-btn:hover {
    box-shadow: inset 0px -3px 6px rgba(0, 0, 0, 0.5),
        /* Realça curvatura no hover */
        0px 8px 12px rgba(0, 0, 0, 0.4);
    /* Realça a sombra externa */
    transform: translateY(-2px);
    /* Levanta ligeiramente */
}

.v-btn:active {
    transform: translateY(2px);
    /* Botão pressionado */
    box-shadow: inset 0px -1px 3px rgba(0, 0, 0, 0.6),
        /* Reduz curvatura interna */
        0px 2px 4px rgba(0, 0, 0, 0.2);
    /* Reduz sombra externa */
}
</style>
